var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgExclamationCircle = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E82A53",
    fillRule: "evenodd",
    d: "M9.6 19.2c5.3019 0 9.6-4.2981 9.6-9.6S14.9019 0 9.6 0 0 4.298 0 9.6s4.298 9.6 9.6 9.6m0-15.6c.6154 0 1.1226.4632 1.1919 1.06l.0081.14v6c0 .6627-.5373 1.2-1.2 1.2-.6154 0-1.1226-.4632-1.192-1.0601L8.4 10.8v-6c0-.6627.5373-1.2 1.2-1.2m.012 9.6c.6627 0 1.2.5373 1.2 1.2 0 .6154-.4632 1.1226-1.06 1.1919L9.6 15.6c-.6627 0-1.2-.5373-1.2-1.2 0-.6154.4633-1.1226 1.06-1.1919z",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgExclamationCircle);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/exclamation-circle.c6332057013b46ecf506e3674e5a18d2.svg";